export default "__VITE_ASSET__CQkWWv6f__"